import React from 'react';
import { Box, FormControl, FormControlLabel, Switch, TextField, Typography } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import appConfig from '../../../config/appConfig';

const WebhookConfigureModal = ({ formData, setFormData, isGlobal }) => {
  const url = formData.url.trim();

  let errorMessage = '';

  if (url !== '' && !/^https:\/\/(?!localhost)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/.test(url)) {
    errorMessage = 'Please enter a valid HTTPS URL';
  }

  return (
    <>
      <Typography mb={1}>Endpoint URL *</Typography>
      <TextField
        fullWidth
        required
        type="url"
        value={formData.url}
        onChange={(e) => setFormData({ ...formData, url: e.target.value })}
        placeholder={`https://your-server.com/webhooks/${appConfig.vendorSlug}`}
        error={!!errorMessage}
        helperText={
          errorMessage && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                color: 'error.main',
                marginLeft: -1.5,
              }}
            >
              <ErrorOutlineOutlinedIcon sx={{ fontSize: 16 }} />
              {errorMessage}
            </Box>
          )
        }
      />

      <Typography mt={3} mb={1}>
        Destination Name *
      </Typography>
      <TextField
        fullWidth
        required
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        placeholder="e.g., Oracle ERP-Production"
      />

      <Typography mt={3} mb={1}>
        Description (Optional)
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        value={formData.description}
        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        placeholder="A brief description of this webhook's purpose..."
      />
      {!isGlobal && (
        <Box
          sx={{
            p: 2,
            mt: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#313131',
            borderRadius: 1,
          }}
        >
          <Typography>Exclude events from global webhook</Typography>
          <Switch
            checked={formData.isExcludedFromGlobalConfig}
            onChange={(e) =>
              setFormData({
                ...formData,
                isExcludedFromGlobalConfig: e.target.checked,
              })
            }
          />
        </Box>
      )}
      <Box
        sx={{
          background: '#1f2937',
          borderRadius: 2,
          p: 3,
          mt: 2,
        }}
      >
        <Typography fontWeight={600} mb={2}>
          Configuration Summary
        </Typography>

        <Typography variant="body2" color="gray">
          Business Profiles: {formData.businessProfiles.length} selected
        </Typography>

        <Typography variant="body2" color="gray">
          Events: {formData.events.length} event type(s)
        </Typography>
      </Box>
    </>
  );
};

export default WebhookConfigureModal;
